export interface SystemModule {
  key: string
  label: string
  category: 'core' | 'academic' | 'operations' | 'finance' | 'admin'
}

export const SYSTEM_MODULES: SystemModule[] = [
  { key: 'dashboards', label: 'Dashboards', category: 'core' },
  { key: 'admissions', label: 'Admissions', category: 'academic' },
  { key: 'academics', label: 'Academics', category: 'academic' },
  { key: 'ecommerce', label: 'eCommerce', category: 'operations' },
  { key: 'school-bus', label: 'School Bus', category: 'operations' },
  { key: 'communication', label: 'Communication', category: 'core' },
  { key: 'event-management', label: 'Event Management', category: 'operations' },
  { key: 'finance', label: 'Finance', category: 'finance' },
  { key: 'accounting', label: 'Accounting', category: 'finance' },
  { key: 'hrms', label: 'HRMS', category: 'admin' },
  { key: 'procurement', label: 'Procurement', category: 'operations' },
  { key: 'visitors-management', label: 'Visitors Management', category: 'operations' },
  { key: 'alumni', label: 'Alumni', category: 'academic' },
  { key: 'hostel-management', label: 'Hostel Management', category: 'operations' },
  { key: 'facility-management', label: 'Facility Management', category: 'operations' },
  { key: 'after-school', label: 'After School', category: 'academic' },
  // The /extracurricular/* routes are gated on this key (App.tsx ModuleGate).
  // It was missing here, so role defaults and the Tools → Module Assignment
  // screen could never switch it on for non-admin roles.
  { key: 'extracurricular', label: 'Extracurricular Clubs', category: 'academic' },
  { key: 'canteen-management', label: 'Canteen Management', category: 'operations' },
  { key: 'library-management', label: 'Library Management', category: 'operations' },
  { key: 'infirmary', label: 'Infirmary', category: 'operations' },
  { key: 'fixed-asset-mgt', label: 'Fixed Asset Mgt', category: 'finance' },
  { key: 'lms', label: 'LMS', category: 'academic' },
  { key: 'help-desk', label: 'Help Desk', category: 'admin' },
  { key: 'knowledge-base', label: 'Knowledge Base', category: 'admin' },
  { key: 'tools', label: 'Tools', category: 'admin' },
  { key: 'inventory-mgt', label: 'Inventory Mgt Sys.', category: 'operations' },
  { key: 'setup', label: 'Set up', category: 'admin' },
]

/**
 * Default modules per role. Mirrors the hardcoded getMenuItemsForRole() switch.
 * Used as fallback when no DB assignments exist for a tenant.
 */
export const DEFAULT_ROLE_MODULES: Record<string, string[]> = {
  admin: [
    'dashboards', 'admissions', 'academics', 'ecommerce', 'school-bus',
    'communication', 'event-management', 'finance', 'accounting', 'hrms',
    'procurement', 'visitors-management', 'alumni', 'hostel-management',
    'facility-management', 'after-school', 'extracurricular', 'canteen-management',
    'library-management', 'infirmary', 'fixed-asset-mgt', 'lms',
    'help-desk', 'knowledge-base', 'tools', 'inventory-mgt', 'setup',
  ],
  teacher: [
    'academics', 'ecommerce', 'school-bus', 'communication',
    'event-management', 'accounting', 'visitors-management',
    'canteen-management', 'library-management', 'hrms', 'infirmary', 'lms',
  ],
  parent: [
    'admissions', 'academics', 'finance', 'school-bus',
    'communication', 'event-management', 'visitors-management',
    'infirmary', 'library-management', 'extracurricular',
  ],
  student: [
    'academics', 'school-bus', 'communication', 'event-management',
    'library-management', 'infirmary', 'after-school', 'extracurricular',
  ],
  alumni: [
    'alumni', 'communication', 'library-management',
  ],
}

export const SIDEBAR_ROLES = ['admin', 'teacher', 'parent', 'student', 'alumni'] as const

export const ROLE_DISPLAY_NAMES: Record<string, string> = {
  admin: 'Administrator',
  teacher: 'Teacher',
  parent: 'Parent',
  student: 'Student',
  alumni: 'Alumni',
}